/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddLeadToStageDto } from "../models/AddLeadToStageDto";
import type { AjaxResponseOfLeadDto } from "../models/AjaxResponseOfLeadDto";
import type { AjaxResponseOfListOfSalesKanbanDto } from "../models/AjaxResponseOfListOfSalesKanbanDto";
import type { AjaxResponseOfListOfStageWithLeadsDto } from "../models/AjaxResponseOfListOfStageWithLeadsDto";
import type { AjaxResponseOfMoveLeadResponseDto } from "../models/AjaxResponseOfMoveLeadResponseDto";
import type { AjaxResponseOfPagedLeadsResultDto } from "../models/AjaxResponseOfPagedLeadsResultDto";
import type { AjaxResponseOfSalesKanbanDto } from "../models/AjaxResponseOfSalesKanbanDto";
import type { CreateOrUpdateSalesKanbanDto } from "../models/CreateOrUpdateSalesKanbanDto";
import type { MoveLeadToStageDto } from "../models/MoveLeadToStageDto";
import type { ReorderLeadsInStageDto } from "../models/ReorderLeadsInStageDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class SalesKanbanAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfSalesKanbanDto Success
   * @throws ApiError
   */
  public getAllSalesKanbans({
    filter,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfListOfSalesKanbanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/sales-kanban",
      query: {
        filter: filter,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfSalesKanbanDto Success
   * @throws ApiError
   */
  public createOrUpdateSalesKanban({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateSalesKanbanDto;
  }): CancelablePromise<AjaxResponseOfSalesKanbanDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/sales-kanban",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfLeadDto Success
   * @throws ApiError
   */
  public addLeadToStage({
    requestBody,
  }: {
    requestBody?: AddLeadToStageDto;
  }): CancelablePromise<AjaxResponseOfLeadDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/sales-kanban/stages/leads",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfMoveLeadResponseDto Success
   * @throws ApiError
   */
  public moveLeadToStage({
    requestBody,
  }: {
    requestBody?: MoveLeadToStageDto;
  }): CancelablePromise<AjaxResponseOfMoveLeadResponseDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/sales-kanban/stages/leads/move",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        409: `Conflict`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfLeadDto Success
   * @throws ApiError
   */
  public removeLeadFromKanban({
    leadId,
  }: {
    leadId: string;
  }): CancelablePromise<AjaxResponseOfLeadDto> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/sales-kanban/stages/leads/{leadId}",
      path: {
        leadId: leadId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPagedLeadsResultDto Success
   * @throws ApiError
   */
  public getLeadsByStage({
    stageId,
    skipCount,
    maxResultCount,
  }: {
    stageId: number;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedLeadsResultDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/sales-kanban/stages/{stageId}/leads",
      path: {
        stageId: stageId,
      },
      query: {
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public reorderLeadsInStage({
    stageId,
    requestBody,
  }: {
    stageId: number;
    requestBody?: ReorderLeadsInStageDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/sales-kanban/stages/{stageId}/leads/reorder",
      path: {
        stageId: stageId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteSalesKanban({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/sales-kanban/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfSalesKanbanDto Success
   * @throws ApiError
   */
  public getSalesKanban({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfSalesKanbanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/sales-kanban/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfStageWithLeadsDto Success
   * @throws ApiError
   */
  public getStagesWithLeads({
    salesKanbanId,
  }: {
    salesKanbanId: number;
  }): CancelablePromise<AjaxResponseOfListOfStageWithLeadsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/sales-kanban/{salesKanbanId}/stages-with-leads",
      path: {
        salesKanbanId: salesKanbanId,
      },
    });
  }
}
